<template>
    <div>
        <div style="display: flex; align-items: center; margin-bottom: 10px">
            <div style="display: flex; flex-direction: row; align-items: center">
                <div style="display: flex">
<!--                    <div v-if="subtitle" class="overflow" style="text-transform: uppercase; font-weight: 600; color: grey">{{subtitle}}</div>-->

                    <h1 class="page-header">{{title}}</h1>
                    
                    
                </div>
                <slot name="title-suffix" > </slot>
                
                <div class="ml-2" style="display: flex; align-items: center;">
                    <v-btn v-if="editable" icon variant="text" size="small" @click.stop="onEdit" class="mr-1"><v-icon>mdi-pencil</v-icon></v-btn>
                    <v-btn v-if="deletable" icon variant="text" size="small" @click.stop="onDelete" class="mr-1"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
                    <v-btn v-if="shareable" icon variant="text" size="small" @click.stop="onShare" class="mr-1"><v-icon>mdi-share</v-icon></v-btn>
                    <v-btn v-if="printable" icon variant="text" size="small" @click.stop="onPrint" :loading="printing" class="mr-1"><v-icon>mdi-printer</v-icon></v-btn>
                    <v-menu location="bottom" :nudge-bottom="8" v-if="menu">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                icon
                                variant="text"
                                size="small"
                                v-bind="props"
                            >
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <slot name="menu-content"></slot>

                    </v-menu>
                    <v-btn v-if="addable" icon variant="text" size="small" @click="$emit('add')" class="mr-1"><v-icon>mdi-plus</v-icon></v-btn>
                </div>
                
                <slot name="title-right"></slot>
            </div>
            <v-spacer></v-spacer>
            <slot name="right-content"/>

        </div>
        <slot name="below"></slot>
        <v-divider v-if="divider" class="mt-5 mb-5"></v-divider>
       
<!--        <v-alert-->
<!--            border="left"-->
<!--            color="warning"-->
<!--            dark-->
<!--        >-->
<!--             <span class="mr-3"><v-icon>mdi-alert</v-icon></span>Profile is currently in an event-->
<!--        </v-alert>-->
    </div>


</template>

<script>
export default {
    name: "PageHeader",
    emits: ['edit', 'delete', 'share', 'print', 'add'],
    props: {
        title: {
            required: true,
            type: String
        },
        subtitle: {
            type: String
        },
        editable: {
            type: Boolean
        },
        deletable: {
            type: Boolean
        },
        shareable: {
            type: Boolean
        },
        addable: {
            type: Boolean
        },
        printable: {
            type: Boolean
        },
        menu: {
            type: Boolean
        },
        printing: {
            type: Boolean
        },
        divider: {
            type: Boolean
        }

    },
    methods: {
        onEdit() {
            this.$emit('edit');
        },
        onDelete() {
            this.$emit('delete');
        },
        onShare() {
            this.$emit('share');
        },
        onPrint() {
            this.$emit('print');
        }
    }
}
</script>

<style scoped>
.page-header {
    font-size: 2rem;
    font-weight: 600;
    font-family: 'Inter', sans-serif;
    color: #1F2937;
    letter-spacing: -0.02em;
}
</style>